import { useContext } from "react";
import UserContext from "state/User/context";

const useUser = () => {
  const context = useContext(UserContext);
  return {
    dispatch: context.dispatch,
    user: context.state.data,
  };
};

export default useUser;
